export var isDate = function (str) {
    var a = str.match(/^(\d{1,2})(:)?(\d{1,2})\2(\d{1,2})$/);
    if (a == null) return false;
    return !(a[1] > 24 || a[3] > 60 || a[4] > 60);
}

